export type { BannerProps } from './Banner.types'
export { default as Banner } from './Banner'